import React from 'react';

import cn from 'classnames';

import { Stack } from '@mui/material';

import './Icon.scss';

interface IProps {
  title?: string;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void;
  className?: string;
  children: React.ReactNode;
  isExpanded?: boolean;
}

const Icon = ({ title, onClick, className, children, isExpanded }: IProps) => {
  return (
    <Stack alignItems="center" gap="12px" className="icon cursor-pointer">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        className={cn('icon__wrapper', className)}
        onClick={onClick}
      >
        {children}
      </Stack>
      {isExpanded && <span>{title}</span>}
    </Stack>
  );
};

export default Icon;
